import ForgotPassword from "../pages/auth/ForgotPassword";
import ResetPassword from "../pages/auth/ResetPassword";
import Setup from "../pages/auth/Setup";
import Signin from "../pages/auth/Signin";
import Signup from "../pages/auth/Signup";
import UnAuthenticated from "../middlewares/UnAuthenticated";
import Authenticated from "../middlewares/Authenticated";
import EmailVerification from "../pages/auth/EmailVerification";
import VerifyEmail from "../pages/auth/VerifyEmail";
import { confirmToken } from "../adapters/authentication";
import NoPage from "../pages/NoPage";
// eslint-disable-next-line import/no-anonymous-default-export
export const authRoutes = [
    {
        path: "/auth/sign-up",
        element: <UnAuthenticated>
             <Signup / >
        </UnAuthenticated>,
        errorElement: <NoPage />
    },
    {
        path: "/auth/sign-in",
        element: <UnAuthenticated>
            <Signin / >
        </UnAuthenticated> ,
    },
    {
        path: "/forgot-password",
        element: <UnAuthenticated>
            <ForgotPassword / >
        </UnAuthenticated>,
    },
    {
        path: "/reset-password/:token",
        element: <UnAuthenticated >
            <ResetPassword />
        </UnAuthenticated>,
        errorElement: <NoPage />,
        loader: async ({ params }) => {
            try {
                await confirmToken(params.token).then((res) => {
                    if(res.status === 200 && res.data.isValid){
                        return
                    }else if(res.status !== 200){
                        throw new Response("Not Found", {
                            status: 401,
                            statusText: 'Invalid token verification'
                        });
                    }
                })
            } catch (e) {
                throw new Response("Not Found", {
                    status: 400
                });
            }
        }
    },
    {
        path: "/email-verification/",
        element: <Authenticated> <EmailVerification /> </Authenticated> ,
    },
    {
        path: "/auth/profile-setup",
        element: <Authenticated>
            < Setup / >
        </Authenticated>,
    },
    {
        path: "/verify-email/:token",
        element: <Authenticated>
            <VerifyEmail />
        </Authenticated>,
    }
    
]

